module.exports = __webpack_public_path__ + "static/media/Infotos-sample2.a8fa75aa.jpg";